export enum IconPositionType {
  PosLeft = 'posLeft',
  PosRight = 'posRight',
  PosBottom = 'posBottom',
}
